import React, { useState, useEffect } from "react";
import placeholderAvatar from '../../../assets/img/placeholderprofile.png';
import getIcon from "../../../utils/Icon";
import ProfileProgress from "../ProfileProgress";
import useTelegram from "../../../hooks/useTelegram";
import userApi from "../../../api/userApi";
import Lottie from 'lottie-react';

import crysal_placeholder from '../../../assets/lottie/crysal_placeholder.json'
export default function Profile({ onAvatarClick }) {
    const tg = useTelegram();
    const telegramUser = tg.initDataUnsafe?.user;

    const firstName     = telegramUser?.first_name  || 'Alexander';
    const lastName      = telegramUser?.last_name   || 'Piterson';
    const username      = telegramUser?.username    || '';
    const [avatarUrl, setAvatarUrl] = useState(placeholderAvatar);

    useEffect(() => {
        userApi.getMyAvatar()
            .then(({ photoUrl }) => {
                if (photoUrl) setAvatarUrl(photoUrl);
            })
            .catch(() => {});
    }, []);

    const lines = 6
    const progress =0
    return (
        <div className="w-full h-[170px]  px-[15px] py-[24px] flex flex-row justify-start  gap-[13px] border-b-2 border-[#353232]">
            <div className="w-[90px] h-[122px] flex flex-col items-center justify-center gap-[6px]">
                {/* Аватар */}
                <div
                    className="relative w-[90px] h-[90px] rounded-full overflow-hidden active:opacity-70 transition-opacity"
                    // onClick={onAvatarClick}
                >
                    <img
                        src={avatarUrl}
                        alt="avatar"
                        className="w-[90px] h-[90px] object-cover rounded-full"
                    />
                </div>

                {/* Лейбл ПОД АВАТАРКОЙ */}
                {/* не убирать потом будет нодбавлено просто за комментирован */}
                {/* <div className="w-[56px] h-[26px] rounded-[40px] overflow-hidden mt-[-18px]">
                    <div
                        className="w-full h-full text-black font-bold flex items-center justify-center px-[12px] py-[4px] bg-gradient-to-r from-[#3A88F7] via-[#3A88F7] to-[#D240D2] rounded-[12.65px] relative">
                        Ultra
                    </div>

                </div>

              
                <div className="w-[90px] h-[14px] text-center text-[#959595] font-semibold text-[12px] leading-[14px]">
                  <span className={'font-roboto'}>  24</span> days left
                </div> */}
            </div>

            <div className={'flex flex-col h-[80px] mt-[21px] gap-[18px]'}>
                <div className={'flex flex-row gap-[10px]'}>
                    <Lottie
                        animationData={crysal_placeholder}
                        loop={false}
                        autoplay={true}
                        className="w-[48px] h-[48px]"
                    />

                    <div className={'flex flex-col'}>
                        <span className={'text-white font-semi text-[18px] w-full whitespace-nowrap`'}>{firstName}  {lastName}</span>
                        <span className={'text-profilt_sub_title/70 font-semi text-[14px] w-full whitespace-nowrap`'}>Warrior</span>
                    </div>

                </div>
                <div className={'flex flex-row w-full h-[14px] items-center  gap-[9px]'}>
                    <ProfileProgress lines={lines}/>
                    <div className={'whitespace-nowrap text-[12px] text-[#959595]'}>
                     <span className={'font-roboto'}>   {progress + '/' + (lines+2)}</span> wins
                    </div>
                </div>
            </div>

        </div>
    );
}
